/* Pop Up */
import { useState } from 'react';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import { Gallery } from "react-grid-gallery";
import galleryImages from './image-gallery-data';
import MyGallery from './MyGallery';

const PopupBar = () => {
    const [ galleryOpen, setGalleryOpen ] = useState(false);
    return(
        <div>
        <Popup trigger={<button>About</button>} position="right center" modal contentStyle={{overflow: "auto", width:"80%",maxHeight: "90%", backgroundColor: "#E7E1DB"}}>
        <div className="popupContainer"> 
            <h2 className="popTitle">About the project</h2>
            <div className="popText">
                <p>
                Know Your Neighbors is a project born from my passion for local wildlife observation.
                </p>
                <p>
                In academia, I’ve worked in many animal-related roles. I’ve been a lab researcher studying poison frogs, a Stanford conservation technician, and a physiology instructor. 
                </p>
                <p>
                Throughout these experiences, I have seen that certain animal species get prioritized above others in the sciences. Sometimes they’re model organisms (like Xenopus frogs). Sometimes they’re particularly “unusual” organisms (like Poison dart frogs). Other times they’re endangered species (like Stanford’s California tiger salamander population). 
                </p>
                <p>
                While these species are interesting and important, they are not the animals we encounter most frequently while we are living our lives. The more common animals, like squirrels, birds, and lizards, often pass by us unnoticed. Rarely do we take the time to learn about the creatures whom we encounter most often. 
                </p>
                <p>
                In my opinion, it is the humble animals whom we share our space with that we should know the most about. They live right outside our doors. We see them every day. These are our neighbors. We should know their names, their faces, and their needs. 
                </p>
                <p>
                Such knowledge benefits both us and them immensely. It makes life more vivid, more real. It dissolves the boundary between “us” and “them,” “humans” and “nature.” It turns a world full of strangers into a world full of friends: our neighbors. 
                </p>
                <p>
                This fosters empathy. When we know our neighbors personally, when we connect with nature intimately, we deeply understand the importance of protecting it. 

                </p>
                <p>
                This knowledge also grounds us in a sense of place. It contextualizes our environment. It makes our experience richer. When a bird hops past me on my way to work, it is not just a bird, but my neighbor, the Dark-eyed junco. Knowing our neighbors make a place feel like home. In doing so, we cease to be simple visitors to the environment. We begin to be native to the environment: a part of nature, rather than apart from nature. 

                </p>
                <p>
                The miracle of life is an incredible, mesmerizing thing. Nothing inspires reflection on this quite like observing animals. They go about their business, and as we watch, we can observe the unity of all life, the miraculous quality of being alive which we all share.  

                </p>
                <p>
                You don’t need to go on a safari. The wild is here. Go outside, sit on a bench, and watch a single squirrel. In just one little friend, the whole universe is laid bare for us to ponder. I have seen hundreds of frogs in the course of my works, but every single one I meet still brings a tear to my eye. Sitting at the lake to watch the gophers build their homes always excites me.

                </p>
                <p>
                Like us, our neighbors live, breathe, eat, seek shelter. In the vast emptiness of our universe, we exist together, here, and now.  Between us, we share the most rare and improbable thing in all of the universe: the quality of being alive. And you can see this right outside. 

                </p>
                <p>
                Of course, it’s easy to say that people should learn about local wildlife. 
                But traditional field guides and other identification resources can be broad 
                in scope and intimidating to beginners.  So I set out to create Know Your Neighbors, 
                a simple, local field guide, made to be accessible and enjoyable for all wildlife 
                observers, including beginners. It focuses on Stanford’s most frequently observed 
                local fauna, providing opportunities for identification and education for everyone 
                in the community. It’s simple to use, free, and compatible with mobile devices. 
                I hope that you will use it to get to know the next animal neighbor you meet.
                </p>
            </div>
        </div>
        </Popup>

        <Popup trigger={<button>Biography</button>} position="right center" modal contentStyle={{overflow: "auto", width:"80%",maxHeight: "90%", backgroundColor: "#E7E1DB"}}>
        <div className="popupContainer">
        <h2 className="popTitle">About me</h2>
            <div className='photoContainer'>
                <img className="bioPhoto" src={require('./photos/me.jpeg')} alt="ENTER"/>
            </div>
            <p className="popText">
                Rachel D’Agui is a programmer, scientist, and passionate 
                admirer of the miracle of life. She holds an M.A. in Earth 
                Systems and a B.A. in Philosophy from Stanford University. 
                During her time as a student, she studied poison frogs, worked 
                in field conservation, and taught science. Her work has included
                surveying for Western burrowing animals, California Tiger salamanders,
                California red-legged frogs, and many of the other species included in 
                the guide. You can find more of her work on her website, 
                <a href="https://p0llyw0g.com/"> p0llyw0g.com</a>.
            </p>
        </div>
        </Popup>

        <Popup trigger={<button>FAQ</button>} position="right center" modal contentStyle={{overflow: "auto", width:"80%",maxHeight: "90%", backgroundColor: "#E7E1DB"}}>
        <div className="popupContainer">
        <h2 className="popTitle">Frequently Asked Questions</h2>
            <ul className="popText">

            <li className='question'>What is Know Your Neighbors?</li>
                <ul>
                <li className='answer'>
                Know Your Neighbors is a simple, hyper-local field guide, 
                made to be accessible and enjoyable for all suburban explorers, 
                including beginners. I hope that you will feel inspired to 
                pay closer attention to our animal neighbors as you live and
                work on campus.
                </li>
                </ul>

            <li className='question'>What's special about Know Your Neighbors?</li>
                <ul>
                <li className='answer'>
                Most field guides cover a large expanse of area and a great number
                of species. This can be confusing to beginner wildlife observers.
                Know Your Neighbors sticks to an especially local context, the 
                Stanford campus, in order to make identification simple and 
                accessible for everyone. Because of this local specificity, 
                the guide also has specific suggestions for where you might find 
                each species, which most traditional field guides cannot do.
                Finally, it's free and comptaible with both mobile and desktop platforms. 
                </li>
                </ul>    

            <li className='question'>How do I use the guide?</li>
                <ul>
                <li className='answer'>
                    Click on an animal's name to see detailed information,
                    or click on a photo to enlarge it. Use the sort bar
                    to sort by rarity or by class. 
                </li>
                </ul>

                <li className='question'>Who made this?</li>
                <ul>
                <li className='answer'>
                    I did! My name is Rachel, and I pursued 2 degrees 
                    at Stanford while working as a field technician 
                    for the Stanford Conservation Program. I have
                    firsthand experience with most of the listed species.
                    Check out the "Biography" tab for more info about me.
                </li>
                </ul>

                <li className='question'>Is this guide comprehensive? How did you choose the species?</li>
                <ul>
                <li className='answer'>
                    This guide is <em>not</em> comprehensive. I chose
                    the species myself based on what I encountered most
                    often while working in field conservation on Stanford's lands.
                    My goal was to prioritize the most commonly observed species,
                    while also including a few of our more rare neighbors,
                    like the California tiger salamander and the California red-legged
                    frog.
                </li>
                </ul>

                <li className='question'>How did you determine the rarity of each species?</li>
                <ul>
                <li className='answer'> 
                    I gave each species a rarity value of either Very Common,
                    Less Common, or Rare. Very Common species are those which 
                    you are likely to observe without trying. Less common species
                    can be observed with some effort. Rare species are typically only found
                    in more remote areas of Stanford land, which are likely to require 
                    a <a href="https://dish.stanford.edu/plan-your-visit/application-use-university-foothill-lands">Foothills Permit.</a>
                </li>
                </ul>

                <li className='question'>What is a Foothills Permit?</li>
                <ul>
                <li className='answer'> 
                    A <a href="https://dish.stanford.edu/plan-your-visit/application-use-university-foothill-lands">Foothills Permit </a> 
                    is a permit avaiable only to Stanford affiliates. This
                    permit enables the holder to use Stanford Foothills land for 
                    academic activities like research and projects. 
                </li>
                </ul>
            </ul>
            </div>
        </Popup>

        <Popup
            trigger={<button>Gallery</button>}
            modal
            nested
            contentStyle={{overflow: "auto", width:"80%",height: "90%", backgroundColor: "#E7E1DB"}}
            closeOnDocumentClick={false}
        >
            {close => (
            <div className="modal">
                <div style={{display: "flex", justifyContent: "flex-end", paddingTop: "8px", paddingRight: "16px"}}>
                    <button className="close" onClick={close} style={{ }}>
                        &times;
                    </button>
                </div>
                
                <div className="galleryPopupContainer">
                    <h2 className="popTitle">My Gallery</h2>
                    <p className="popText">Please enjoy some of my field photos from the Stanford area. All rights reserved.</p>
                    <MyGallery/>
                </div>
            </div>
            )}
        </Popup>
        </div>
    )
};

export default PopupBar
